import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';
import { useGetPostingDetails } from '../../../../../../domain/PermanentJobs';
import { getJobApplications, updateJobApplication } from '../../../../../../services/pp';
import { showSuccessMessage } from '../../../../../../utils';
import { ApplicationStatus } from '../../../shared/constants';

export const useJobDetails = (jobId) => {
  const [job, setJob] = useState(null);

  const {
    data: currentJobPosting,
    isLoading,
    refetch,
  } = useGetPostingDetails({ postingId: jobId }, { enabled: !!jobId });

  const { data: jobApplicationsResponse } = useQuery({
    queryKey: ['getJobApplications', jobId],
    queryFn: () => getJobApplications(jobId),
    retry: false,
    enabled: !!jobId,
  });

  const hireCandidate = useMutation({
    mutationFn: ({ applicationId }) =>
      updateJobApplication(jobId, applicationId, { status: ApplicationStatus.HIRED }),
    onSuccess: async () => {
      refetch();
      showSuccessMessage({ message: 'GoTu Candidate Successfully Hired' });
    },
  });

  useEffect(() => {
    if (currentJobPosting) {
      setJob(currentJobPosting);
    }
  }, [currentJobPosting]);

  const availableCandidates = useMemo(() => {
    if (!jobApplicationsResponse?.data) return [];

    return jobApplicationsResponse.data.filter(
      (application) =>
        application.status === ApplicationStatus.NEW ||
        application.status === ApplicationStatus.INTERESTED ||
        application.status === ApplicationStatus.CONTACTED,
    );
  }, [jobApplicationsResponse?.data]);

  return {
    job,
    isLoading,
    availableCandidates,
    hireCandidate,
  };
};
